<script setup>
import { ref } from 'vue'

const emit = defineEmits(['update:content'])
const props = defineProps({
    content: {
        type: Boolean,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false,
    }
})

const done = ref(props.content)

const toggleDone = () => {
    if (props.disabled) return
    done.value = !done.value
    emit('update:content', done.value)
}

</script>
<template>
    <button
        @click="toggleDone"
        class="w-4 h-4 relative"
    >
        <span
            class="border-2 absolute transition-all"
            :class="[disabled === true ? 'cursor-not-allowed' : 'cursor-pointer', done === true ? 'rounded-full bg-myflowGreen border-myflowGreen -inset-px' : 'inset-0 rounded-sm border-gray-400']"
        >
            <span
                class="flex items-center justify-center absolute inset-0 transition-all duration-75"
            >
                <i class="fa-solid fa-check text-white m-auto" style="font-size: 10px" v-if="done === true"></i>
            </span>
        </span>
    </button>
</template>
